export function createCommandKey(scope: string): string {
  const bytes = crypto.getRandomValues(new Uint8Array(18));
  const entropy = Array.from(bytes, (value) =>
    value.toString(16).padStart(2, "0"),
  ).join("");
  return `${scope}:${Date.now().toString(36)}:${entropy}`.slice(0, 100);
}
